module.exports = __webpack_public_path__ + "static/giraffeanimalmain-714d2f84fdd955e98407baa2b159aee4.png";